import { FC, useState } from 'react';
import { useNavigate } from "react-router-dom";
import css from './index.module.css';
import AddPopupProduct from '@components/addProductPopup';
import useUserData from '@hooks/useUserData';
import { toast } from 'sonner';
import axios from 'axios';
import CountContainer from '@components/countContainer';

interface MiniProductInt {
    id: number;
    product?: any;
    title: string;
    price: number; 
    image: string;
    unit: 'ШТ' | 'КГ';
    quantity: number;
}

const MiniProduct: FC<MiniProductInt> = ({ id, title, price, image, unit = 'ШТ', quantity = 0 }) => {
    const navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState<any>();
    const { cartData, favoriteData, refreshFavoriteData } = useUserData();

    const selectProduct = () => {
        setSelectedProduct({ id, title, price, image, unit, quantity });
        setShowPopup(true);
    };

    const goProduct = () => {
        navigate(`/webapp/product/${id}`);
    };

    const manageFavorite = (type: number, id: number) => {
        axios.post(`${import.meta.env.VITE_API_URL}/user/favorites/${type === 0 ? "add" : "remove"}`, { productId: id },
        {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
        })
        .then((_) => {
            toast.success(type === 0 ? "Добавили продукт в избранное" : "Удалили продукт из избранного");
            refreshFavoriteData();
        })
        .catch((error) => {
            console.log(error);
        });
    };

    return (
    <>
        <AddPopupProduct showPopup={showPopup} setShowPopup={setShowPopup} product={selectedProduct} />
        <div className={css.miniProduct} onClick={goProduct}>
            <img src={image ? image : '/assets/images/noImage.jpg'} alt={title} className={css.productImage} />

            <div className={css.favorite}>
                <i className={favoriteData.find(favorite => favorite.productId == id) ? `${css.favoriteIcon} fi fi-sr-heart` : "fi fi-rr-heart"} onClick={(e) => { e.stopPropagation(); manageFavorite(favoriteData.find(favorite => favorite.productId === id) ? 1 : 0, id); }}></i>
            </div>
            
            <div className={css.textInfo}>
                <div>
                    <a style={{ fontWeight: 600, fontSize: 20, color: "#0077FF" }}>{price} ₽ / {unit}</a>
                    <h2 style={{ fontWeight: 500, fontSize: 17 }}>{title}</h2>
                </div>

                {!cartData.find(cart => cart.product.id == id) ? (
                        <button className={css.addToCart} onClick={(e) => { e.stopPropagation(); selectProduct(); }}>В корзину</button>
                    ) : (
                        <CountContainer id={id} unit={unit} />
                    )
                }
            </div>
        </div>
    </>
    );
};

export default MiniProduct;